import './campaigns_tab.less';

import * as Business    from '../business';
import * as Campaigns   from '../campaigns';
import * as Groups      from '../groups';
import * as Templates   from '../campaign_templates';
import { useDispatch }  from 'react-redux';
import classnames       from 'classnames';
import FetchFromServer  from '../components/fetch_from_server';
import Link             from '../components/link';
import React            from 'react';
import TabPage          from '../components/tab_page';

import { ArrowRight }   from 'react-feather';
import { ChevronRight } from 'react-feather';


export default function CampaignsTab({ businessID, tabActive }) {

  const dispatch = useDispatch();

  const statuses = [
    Campaigns.useCampaignsStatuses(businessID),
    Templates.useTemplatesStatuses(businessID),
    Groups.useGroupsStatuses(businessID)
  ];

  function load() {
    dispatch(Campaigns.readCampaigns(businessID));
    dispatch(Templates.readTemplates(businessID));
    dispatch(Groups.readGroups(businessID));
  }

  const business = Business.useBusiness(businessID);

  return (
    <TabPage name="campaigns" title="Campaigns" className="campaigns-tab">
      <FetchFromServer statuses={statuses} load={load}>
        {business && (
          <TabLinks {...{ tabActive, business }}/>
        )}
      </FetchFromServer>
    </TabPage>
  );
}


function TabLinks({ tabActive, business }) {
  return (
    <>
      <div className="block intro">
        <h2>Email Campaigns</h2>
        <p>
          Reach out to customers with promotions, greetings, or updates.
        </p>
        <Link href={`/${business.id}/campaigns/add`} className="button button-fill">
          <div className="label">New Campaign</div>
          <ArrowRight/>
        </Link>
      </div>
      <div className="block links">
        <ul>
          <TabLink
            active={tabActive === 'TemplatesPage'}
            href={`/${business.id}/campaigns/templates`}
            title="Templates"
            subtitle="Our thoughtfully crafted templates are unique to your industry"/>
          <TabLink
            active={tabActive === 'ActivityPage'}
            href={`/${business.id}/campaigns/activity`}
            title="Your Activity"
            subtitle="View your draft, scheduled, and sent campaigns"/>
        </ul>
      </div>
    </>
  );
}


function TabLink({ href, title, subtitle, onClick, active = false, external = false, className }) {
  const tabClassName    = classnames('tab-link', className);
  const anchorClassName = classnames({ external, active });

  return (
    <li className={tabClassName}>
      <Link href={href} className={anchorClassName} onClick={onClick} external={external}>
        <div className="title">{title}</div>
        <div className="subtitle">{subtitle}</div>
        <ChevronRight/>
      </Link>
    </li>
  );
}
